import React from "react";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import moment from 'moment';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import {
  Alert,
  Icon,
  Layout,
  Table,
  Switch,
  Modal,
  message,
  Tooltip,
} from "antd";
import { withParams } from '../../utils/url';

import Footer from "../../components/Footer/Footer";
import classes from "./Unblindings.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getUnblindings,
  deleteUnblindingRequest,
  activateUnblindingRequest,
  unapproveUnblindingRequest,
  approveUnblindingRequest,
  getSitesRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
const routes = require('../../routes.json');
const { Content } = Layout;

class Unblindings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      unblindings: [],
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      unblindingView: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      approvedSelected: null,
    };
  }

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {}, currentPage: 1
      },
      this.getUnblindings
    );
  };

  getUnblindings = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getUnblindings({
        page,
        per_page,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          unblindings: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          unblindings: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        unblindings: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getUnblindings(pagination.current, pagination.pageSize)
    );
  };

  onUnblindingView = (unblinding) => () => {
    this.setState({ unblindingView: unblinding });
  };

  onUnblindingViewHide = () => {
    this.setState({ unblindingView: null });
  };

  onSwitchUnblindingActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteUnblindingRequest(id);
      } else {
        await activateUnblindingRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getUnblindings();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(this.props.i18n.t("Error"));
      console.log(e);
    }
  };

  onSwitchUnblindingApprove = (id, approved) => async () => {
    try {
      if (approved) {
        await unapproveUnblindingRequest(id);
      } else {
        await approveUnblindingRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getUnblindings();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(this.props.i18n.t("Error"));
      console.log(e);
    }
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState((state) => {
      const filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = value;
      return { filtersValue, currentPage: 1 };
    }, this.getUnblindings);
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getUnblindings);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getUnblindings);
  };

  onSelectApprovedStatus = (approvedStatusType) => () => {
    let status;
    const { approvedSelected } = this.state;

    if (approvedSelected === null && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === true && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === false && approvedStatusType === "approved") {
      status = null;
    }

    if (approvedSelected === null && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === false && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === true && approvedStatusType === "unapproved") {
      status = null;
    }

    this.setState((_) => ({ approvedSelected: status, currentPage: 1 }), this.getUnblindings);
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      unblindings,
      currentPage,
      total,
      pageSize,
      unblindingView,
      sortedInfo,
    } = this.state;

    const columns = [
      {
        dataIndex: "id",
        key: "record_id",
        title: this.props.i18n.t('NamespaceUnblindings:ID#'),
        render: (val, unblinding) => get(unblinding, "id"),
      },
      {
        dataIndex: "user",
        key: "user",
        title: this.props.i18n.t('NamespaceUnblindings:Requested By'),
        render: (val, unblinding) => get(unblinding, "user.username"),
      },
      {
        dataIndex: "user_approved",
        key: "user_approved",
        title: this.props.i18n.t('NamespaceUnblindings:Approved By'),
        render: (val, unblinding) => get(unblinding, "user_approved.username"),
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t('NamespaceUnblindings:Created At'),
        render: (val, unblinding) => moment(get(unblinding, "created")).format("YYYY-MM-DD"),
      },
      {
        dataIndex: "subject",
        key: "subject",
        title: this.props.i18n.t('Subject ID'),
        render: (val, unblinding) => <div>
        <Tooltip placement="topLeft" title={this.props.i18n.t('View Subject Profile')}><Link to={withParams(routes.admin.patientProfileSingle, { subjectID: get(unblinding, 'profile.code')})}>{get(unblinding, 'subject.code')}</Link></Tooltip>
        </div>,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t('Site ID'),
        render: (val, unblinding) => `${get(unblinding, 'site.code')} - ${get(unblinding, 'site.name')}`,
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t('Actions'),
        render: (val, unblinding) => (
          <div className={classes.actions}>
            <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceUnblindings:View')}>
              <Icon
                type="eye"
                theme="filled"
                className={classes.iconEdit}
                onClick={this.onUnblindingView(unblinding)}
              />
            </Tooltip>
            &nbsp; &nbsp;
            <div style={{ width: "90px", display: "flex" }}>
              {((true && unblinding.state === "inactive") ||
                (true && unblinding.state === "active")) && (
                <div>
                  <b className={classes.switchLabel}>{this.props.i18n.t('State')}</b>
                  <br />
                  <Tooltip
                    placement="topLeft"
                    title={this.props.i18n.t('NamespaceUnblindings:Activate / Deactivate unblinding')}
                  >
                    <Switch
                      className={classes.reactivateBtn}
                      checked={unblinding.state === "active"}
                      onChange={this.onSwitchUnblindingActivation(
                        val,
                        unblinding.state
                      )}
                    />
                  </Tooltip>
                </div>
              )}
              &nbsp; &nbsp;
              {unblinding.state === "active" &&
                ((true && !unblinding.approved) ||
                  (true && unblinding.approved)) && (
                  <div>
                    <b className={classes.switchLabel}>{this.props.i18n.t('Approve')}</b>
                    <br />
                    <Tooltip
                      placement="topLeft"
                      title={this.props.i18n.t('NamespaceUnblindings:Approve / Unapprove unblinding')}
                    >
                      <Switch
                        className={classes.reactivateBtn}
                        checked={unblinding.approved}
                        onChange={this.onSwitchUnblindingApprove(
                          val,
                          unblinding.approved
                        )}
                      />
                    </Tooltip>
                  </div>
                )}
            </div>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t('NamespaceUnblindings:Unblinding Requests')}</h3>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <Table
              columns={columns}
              dataSource={unblindings}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: 'both',
              }}
            />

            <Modal
              visible={!!unblindingView}
              onCancel={this.onUnblindingViewHide}
              footer={null}
            >
              {unblindingView && unblindingView.comments}
            </Modal>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Unblindings))
);



// WEBPACK FOOTER //
// ./src/containers/Unblindings/Unblindings.js